export default __webpack_public_path__ + "5483bc7bc59866132e8057d8298ecd28.png";